import React from "react";
import { Spinner } from "reactstrap";

const GenericSpinner = () => {
    return <div style={ {'textAlign':'center'} }>
        <Spinner animation="border" size='sm' type='grow'/>
        <Spinner animation="border" size='sm' type='grow'/>
        <Spinner animation="border" size='sm' type='grow'/>
    </div>
}

export default GenericSpinner